import { useState, useMemo } from 'react';
import { useRequest } from 'ahooks';
import {
  Button,
  PhoneMessage as PhoneMessageIcon,
  Text,
  Toast,
} from '~components';
import { sendSMS } from '~services/Representative/Representative';
import useTimer from '~hooks/useTimer';

import * as Styled from './styled';
import { Props } from './types';

const fiveMinutesInSeconds = 5 * 60;

function SendSMSButton({ id, type }: Props) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const { timer, resetTimer } = useTimer(fiveMinutesInSeconds, {
    onFinish: () => setIsButtonDisabled(false),
  });

  const [isToastVisible, setIsToastVisible] = useState(false);

  const {
    runAsync: fetchSendSMS,
    error: hasError,
    loading: isLoading,
  } = useRequest(sendSMS, {
    manual: true,
    onSuccess: () => {
      setIsToastVisible(true);
    },
    onError: () => setIsButtonDisabled(false),
  });

  async function handleClick() {
    resetTimer();
    setIsButtonDisabled(true);

    await fetchSendSMS(id, type);
  }

  const display = useMemo(() => {
    const minutes = parseInt((timer / 60).toString(), 10);
    const seconds = timer % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }, [timer]);

  return (
    <>
      <Styled.Wrapper>
        {isButtonDisabled && (
          <div>
            <Text as="span" color="neutral-strong">
              {display}
            </Text>{' '}
            <Text as="span">para solicitar um novo SMS.</Text>
          </div>
        )}
        {hasError && !isLoading && (
          <Text as="span" color="neutral-strong">
            Erro ao enviar SMS, tente novamente
          </Text>
        )}
        <div>
          <Button
            onClick={handleClick}
            disabled={isButtonDisabled}
            variant="secondary"
            icon={<PhoneMessageIcon />}
          >
            Reenviar SMS
          </Button>
        </div>
      </Styled.Wrapper>
      <Toast
        variant="success"
        title="SMS enviado com sucesso!"
        isVisible={isToastVisible}
        lifetime={5000}
        onDismiss={() => setIsToastVisible(false)}
      />
    </>
  );
}

export default SendSMSButton;
